import React, { Component } from "react";
import axios from "axios";
import * as PropTypes from "prop-types";
import { Alert, Form, message, Modal, Tabs, Spin } from "antd";

import moment from "moment";

import { API_ERRO_TYPE_CANCEL } from "./../../config/general";

import { companiesService } from "./../../redux/services";

import { UIDrawerForm, UISteps } from "./../../components";

import GeneralInfoFields from "./components/GeneralInfoFields";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

import Employees from "./Employees";
import Adresses from "./Adresses";
import Contacts from "./Contacts";
import Atestados from "./Atestados";

const STEPS = [
	{ key: "general", label: "Informações gerais", icon: <i className="fal fa-clipboard-list" /> },
	{ key: "adresses", label: "Endereços", icon: <i className="fal fa-map-marker-alt" /> },
	{ key: "contacts", label: "Contatos", icon: <i className="fal fa-address-book" /> },
	{ key: "employees", label: "Funcionários", icon: <i className="fal fa-users" /> },
	{ key: "atestados", label: "Atestados de Software", icon: <i className="fal fa-file-certificate" /> },
];

class Edit extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			isSending: false,
			uuid: 0,
			ativo: null,
			settings: null,
			tipo_pessoa: null,
			cnpj_principal: null,
			displayParamsREPP: true,
			displayAppCompany: true,
			displayAppEmployee: true,
			activeKey: "general",
		};

		this._axiosCancelToken = null;
	}

	componentDidMount() {
		this.handleCheckCompanyHasAccessREPP();
	}

	fetchTenants = (value) => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		if (!value.trim().length) {
			this.setState({
				resalesIsLoading: false,
				resales: [],
			});

			return false;
		}

		this.setState({
			resalesIsLoading: true,
		});

		companiesService.getAll({
			search: value,
			// orderBy: "name:asc",
			cancelToken: this._axiosCancelTenantsToken.token,
		})
			.then((response) => {
				this.setState({
					resalesIsLoading: false,
					resales: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					resalesIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			uuid: uuid,
			activeKey: "general",
		});

		companiesService.show({ uuid })
			.then((response) => {
				let item = response.data.data;

				let companies = [];

				if (item.empresa) {
					resales.push({
						id: item.empresa.id,
						nome: item.empresa.nome,
					});
				}

				this.setState({
					settings: {
						app_funcionario: response.data.configuracao.app_funcionario,
						app_empresa: response.data.configuracao.app_empresa,
					},
					cnpj_principal: item.cnpj_principal,
					isLoading: false,
					companies: companies,
					tipo_pessoa: item.tipo_pessoa,
				}, () => {
					// Fill form
					this.fillForm(item);

					this.tabEmployees && this.tabEmployees.init(item);
					this.tabAdresses && this.tabAdresses.init(item);
					this.tabContacts && this.tabContacts.init(item);
					this.tabAtestados && this.tabAtestados.init(item);
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
	};

	fillForm = (data) => {
		this.form.setFieldsValue({
			nome: data.nome,
			ativo: data.ativo,
			cnpj: data.cnpj,
			matriz: data.matriz,
			nome_responsavel: data.nome_responsavel,
			numero_folha: data.numero_folha,
			cargo_responsavel: data.cargo_responsavel,
			cnpj_principal: data.cnpj_principal,
			cei: data.cei,
			cpf: data.cpf,
			im: data.im,
			tipo_pessoa: data.tipo_pessoa,
			rg: data.rg,
			ie: data.ie,
			caepf: data.caepf,
			cno: data.cno,
			data_nascimento: data.data_nascimento ? moment(data.data_nascimento) : null,
			app_empresa: data.app_empresa,
			app_funcionario: data.app_funcionario,
			dia_fechamento_periodo: data.dia_fechamento_periodo ?? 31,
		});

		// Upload
		if (data.avatar) {
			this.upload.setFiles([
				{
					uuid: data.uuid,
					url: data.avatar,
					type: 'image/jpeg',
				}
			]);
		}
	};

	resetFields = () => {
		this.form.resetFields();
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onFinish = (values) => {
		const file = this.upload.getFiles();

		if (file.hasError) {
			Modal.error({
				title: "Ocorreu um erro!",
				content: file.error,
			});

			return false;
		}

		this.setState({
			isSending: true,
		});

		const { uuid } = this.state;

		const data = {
			...values
		};

		// uuid
		data.uuid = uuid;

		if (data.data_nascimento) {
			data.data_nascimento = data.data_nascimento.format("YYYY-MM-DD");
		} else {
			delete data.data_nascimento;
		}

		if (file.files.length) {
			if (!file.files[0].uuid) {
				data.avatar = file.files[0];
			}
		} else {
			data.avatar = null;
		}

		companiesService.edit(data)
			.then((response) => {
				this.setState({
					isSending: false,
				});

				// Reset fields
				this.resetFields();

				// Success message
				message.success("Registro atualizado com sucesso.");

				// Callback
				this.props.onComplete();
			})
			.catch((data) => {
				this.setState({
					isSending: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	handleCheckCompanyHasAccessREPP = () => {
		const companyData = JSON.parse(localStorage.getItem('@mainCompany'));

		this.setState({
			displayParamsREPP: !(!companyData?.app_empresa && !companyData?.app_funcionario),
			displayAppCompany: companyData?.app_empresa,
			displayAppEmployee: companyData?.app_funcionario
		});
	}

	render() {
		const { visible } = this.props;

		const {
			isLoading,
			isSending,
			settings,
			tipo_pessoa,
			displayParamsREPP,
			displayAppCompany,
			displayAppEmployee,
			activeKey,
		} = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={1100}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				icon={<i className="fal fa-building" />}
				title="Editar Empresa"
				subtitle="Atualize as informações gerais da empresa."
				footer={
					<UISteps
						steps={STEPS}
						current={activeKey}
						onChange={(key) => this.setState({ activeKey: key })}
						onCancel={this.onClose}
					/>
				}
			>
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}>
					<Tabs
						activeKey={activeKey}
						onChange={(key) => this.setState({ activeKey: key })}
					>
						<Tabs.TabPane
							forceRender
							tab={<span className="tab-icon-label">{STEPS[0].icon} {STEPS[0].label}</span>}
							key="general"
						>
							<GeneralInfoFields
								tipo_pessoa={tipo_pessoa}
								onTipoPessoaChange={(value) => this.setState({ tipo_pessoa: value })}
								settings={settings}
								displayParamsREPP={displayParamsREPP}
								displayAppCompany={displayAppCompany}
								displayAppEmployee={displayAppEmployee}
								nomeInputRef={(el) => (this.nome = el)}
								uploadRef={(el) => (this.upload = el)}
								onDataNascimentoKeyUp={(e) => {
									if (e.keyCode === 13 || e.keyCode === 9) {
										this.tipo_contrato.focus()
									}
								}}
							/>
						</Tabs.TabPane>
						<Tabs.TabPane
							forceRender
							tab={<span className="tab-icon-label">{STEPS[1].icon} {STEPS[1].label}</span>}
							key="adresses"
						>
							<Adresses
								ref={el => this.tabAdresses = el}
							/>
						</Tabs.TabPane>
						<Tabs.TabPane
							forceRender
							tab={<span className="tab-icon-label">{STEPS[2].icon} {STEPS[2].label}</span>}
							key="contacts"
						>
							<Contacts
								ref={el => this.tabContacts = el}
							/>
						</Tabs.TabPane>
						<Tabs.TabPane
							forceRender
							tab={<span className="tab-icon-label">{STEPS[3].icon} {STEPS[3].label}</span>}
							key="employees"
						>
							<Employees
								ref={el => this.tabEmployees = el}
							/>
						</Tabs.TabPane>
						<Tabs.TabPane
							forceRender
							tab={<span className="tab-icon-label">{STEPS[4].icon} {STEPS[4].label}</span>}
							key="atestados"
						>
							<Atestados ref={el => this.tabAtestados = el} />
						</Tabs.TabPane>
					</Tabs>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Edit;
